import { JsonObject, JsonProperty } from 'json2typescript';

import { Id } from './id';
import { IdAdapter } from '../../client/helpers/serializer/adapters/id.adapter';
import { Question } from './question';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';
import { TestResultInterface } from '../../../core';

@JsonObject('InvestorProfile')
class InvestorProfile {
    @JsonProperty('InvestorProfileId', IdAdapter, true)
    private _profileId: Id = undefined;

    @JsonProperty('InvestorProfileName', StringAdapter, true)
    private _profileName: string = undefined;

    get profileId(): Id {
        return this._profileId;
    }

    get profileName(): string {
        return this._profileName;
    }
}

@JsonObject('TestResult')
export class TestResult implements TestResultInterface {
    @JsonProperty('Code', IdAdapter, true)
    private _clientCode: Id = undefined;

    @JsonProperty('TestId', IdAdapter, true)
    private _testId: Id = undefined;

    @JsonProperty('MifidCompetenceId', IdAdapter, true)
    private _mifidCompetenceId: Id = undefined;

    @JsonProperty('MifidCompetenceDescription', StringAdapter, true)
    private _mifidCompetenceName: string = undefined;

    @JsonProperty('InvestorProfileData', InvestorProfile, true)
    private _profile: InvestorProfile = undefined;

    @JsonProperty('Questions', [Question], true)
    private _questions: Question[] = undefined;

    get clientCode(): Id {
        return this._clientCode;
    }

    get testId(): Id {
        return this._testId;
    }

    get mifidCompetenceId(): Id {
        return this._mifidCompetenceId;
    }

    get mifidCompetenceName(): string {
        return this._mifidCompetenceName;
    }

    get profileId(): Id {
        return this._profile ? this._profile.profileId : undefined;
    }

    get profileName(): string {
        return this._profile ? this._profile.profileName : undefined;
    }

    get questions(): Question[] {
        if (!this._questions) {
            this._questions = [];
        }

        return this._questions.sort((a: Question, b: Question) => {
            if (a.order < b.order) {
                return -1;
            } else if (a.order > b.order) {
                return 1;
            }

            return 0;
        });
    }
}
